import React from 'react';
import { useFormContext } from 'react-hook-form';
import { QuillInputField } from 'components/form';
import { FinanceProgramForm } from '../../../../schema';

interface Props {
  isReadOnly: boolean;
}

export const InsuranceCoverageRequirements = ({ isReadOnly }: Props) => {
  const { control, setValue, getValues } = useFormContext<FinanceProgramForm>();

  return (
    <>
      <QuillInputField
        control={control}
        setValue={setValue}
        getValues={getValues}
        readOnly={isReadOnly}
        label="Coverage Requirements:"
        name="program.fifth.insuranceCoverage.coverageRequirements"
      />

      <QuillInputField
        control={control}
        setValue={setValue}
        getValues={getValues}
        readOnly={isReadOnly}
        label="Certificate Requirements:"
        name="program.fifth.insuranceCoverage.certificateRequirements"
      />

      <QuillInputField
        control={control}
        setValue={setValue}
        readOnly={isReadOnly}
        getValues={getValues}
        label="Other Instructions:"
        name="program.fifth.insuranceCoverage.otherInstructions"
      />
    </>
  );
};
